(() => {
  'use strict';
  if (window.caMakeRoomLoaded) return;
  window.caMakeRoomLoaded = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope = document) {
    const find = selector => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
    find('[data-mr-hero]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const scenes = [...root.querySelectorAll('[data-mr-scene]')];
      const dots = [...root.querySelectorAll('[data-mr-go]')];
      const pause = root.querySelector('[data-mr-pause]');
      const status = root.querySelector('[data-mr-status]');
      let active = 0, timer, userPaused = root.dataset.autoplay !== 'true' || motion.matches;
      const stop = () => { clearTimeout(timer); timer = null; };
      const schedule = () => {
        stop();
        if (userPaused || motion.matches || document.hidden || scenes.length < 2) return;
        timer = setTimeout(() => { show(active + 1, false); }, Math.max(5000, Number(root.dataset.interval) || 8000));
      };
      const updatePause = () => {
        if (!pause) return;
        pause.textContent = userPaused ? 'Play' : 'Pause';
        pause.setAttribute('aria-label', userPaused ? 'Start automatic artwork scenes' : 'Pause automatic artwork scenes');
      };
      function show(index, manual = true) {
        if (!scenes.length) return;
        active = ((index % scenes.length) + scenes.length) % scenes.length;
        scenes.forEach((scene, i) => { scene.hidden = i !== active; });
        dots.forEach((dot, i) => {
          if (i === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (status) {
          status.setAttribute('aria-live', manual ? 'polite' : 'off');
          status.textContent = dots[active]?.getAttribute('aria-label') || `Artwork scene ${active + 1}`;
        }
        schedule();
      }
      root.querySelector('[data-mr-prev]')?.addEventListener('click', () => show(active - 1));
      root.querySelector('[data-mr-next]')?.addEventListener('click', () => show(active + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      pause?.addEventListener('click', () => { userPaused = !userPaused; updatePause(); schedule(); });
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) schedule(); });
      root.addEventListener('shopify:block:select', event => {
        const selected = scenes.findIndex(scene => scene.contains(event.target) || scene === event.target);
        if (selected >= 0) { userPaused = true; show(selected); updatePause(); }
      });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : schedule());
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) stop(); });
      motion.addEventListener('change', () => { if (motion.matches) { userPaused = true; updatePause(); } schedule(); });
      updatePause();
      show(0, false);
    });
    find('[data-mr-room]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const range = root.querySelector('[data-mr-reveal]');
      range?.addEventListener('input', () => {
        root.style.setProperty('--mr-reveal', `${range.value}%`);
        range.setAttribute('aria-valuetext', `${range.value}% before, ${100 - Number(range.value)}% with artwork`);
      });
      const sizes = [...root.querySelectorAll('[data-mr-size]')];
      sizes.forEach(button => button.addEventListener('click', () => {
        root.style.setProperty('--mr-art-cm', button.dataset.mrSize);
        sizes.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
